import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "7CVE/1",
    defaultMessage: "Payment",
    description: "wizard step title",
  },
  description: {
    id: "ZdRdY/",
    defaultMessage:
      "Configure payment gateways to accept payments from your customers.",
    description: "wizard step description",
  },
  noPaymentApps: {
    id: 'ilbXx1',
    defaultMessage:
      "No supported payment apps are installed. You can install and configure payment apps later from the Extensions section.",
    description: "empty state text when no payment apps found",
  },
});
